import React, { useState, useEffect } from "react";
import Dropdown from "@/components/ui/Dropdown";
import { InterViewSlotService } from "../../services/InterViewSlot";
import { toast } from "react-toastify";

const extractMeetingLink = (response) =>
  response?.meeting_link ||
  response?.data?.meeting_link ||
  response?.link ||
  response?.data?.link ||
  response?.slot?.meeting_link ||
  response?.data?.slot?.meeting_link ||
  response?.slot?.link ||
  response?.data?.slot?.link ||
  "";

const getInterviewType = (block, slot) =>
  slot?.interview_type ||
  slot?.interviewType ||
  block?.interview_type ||
  block?.interviewType ||
  "";

const extractCalendarEventScheduled = (response) =>
  response?.calendar_event_scheduled === true ||
  response?.data?.calendar_event_scheduled === true ||
  response?.slot?.calendar_event_scheduled === true ||
  response?.data?.slot?.calendar_event_scheduled === true;

const getSlotMeetingLink = (slot) => slot?.meeting_link || slot?.link || "";

const getSlotCalendarEventScheduled = (block, slot) =>
  slot?.calendar_event_scheduled === true ||
  block?.calendar_event_scheduled === true;

const InterviewDetailsForm = ({
  selectedJob,
  handleCloseSlots,
  candidate,
  onSuccess,
}) => {
  const [selectedDateId, setSelectedDateId] = useState("");
  const [selectedSlotId, setSelectedSlotId] = useState("");
  const [selectedSlotStatus, setSelectedSlotStatus] = useState("");
  const [savedSlotStatus, setSavedSlotStatus] = useState("");
  const [isBooking, setIsBooking] = useState(false);
  const [isGeneratingLink, setIsGeneratingLink] = useState(false);
  const [generatedLink, setGeneratedLink] = useState("");
  const [showCalendarScheduledMessage, setShowCalendarScheduledMessage] =
    useState(false);
  const [use24HourFormat, setUse24HourFormat] = useState(false);

  const bookedSlotId = selectedJob?.booked_interview_slot?.slots?.[0]?.id;

  const selectedBlock =
    selectedJob?.booked_interview_slot?.id === selectedDateId
      ? selectedJob.booked_interview_slot
      : selectedJob?.company_availability_blocks?.find(
        (b) => String(b.id) === String(selectedDateId),
      );

  const selectedSlot = selectedBlock?.slots?.find(
    (s) => String(s.id) === String(selectedSlotId),
  );

  const interviewType = getInterviewType(selectedBlock, selectedSlot);
  const isVideoSlot = interviewType === "Video Interview";

  useEffect(() => {
    if (selectedJob) {
      if (selectedJob.booked_interview_slot) {
        const bookedBlock = selectedJob.booked_interview_slot;
        const bookedSlot = bookedBlock.slots?.[0];
        setSelectedDateId(bookedBlock.id);
        setSelectedSlotId(bookedSlot?.id);
        setSelectedSlotStatus(bookedSlot?.status);
        setSavedSlotStatus(bookedSlot?.status || "");
        setShowCalendarScheduledMessage(
          bookedSlot?.status === "confirmed" &&
            getInterviewType(bookedBlock, bookedSlot) !== "Video Interview" &&
            getSlotCalendarEventScheduled(bookedBlock, bookedSlot),
        );
      } else {
        setSelectedSlotStatus(null);
        setSavedSlotStatus("");
        setSelectedSlotId(null);
        setSelectedDateId(null);
        setGeneratedLink("");
        setShowCalendarScheduledMessage(false);
        const firstBlock = selectedJob.company_availability_blocks?.find(
          (b) => b.slots?.length > 0,
        );
        if (firstBlock) {
          setSelectedDateId(firstBlock.id);
        }
      }
    }
  }, [selectedJob]);

  useEffect(() => {
    const bookedBlock = selectedJob?.booked_interview_slot;
    const bookedSlot = bookedBlock?.slots?.[0];
    if (bookedSlotId) {
      if (getInterviewType(bookedBlock, bookedSlot) === "Video Interview") {
        setGeneratedLink(getSlotMeetingLink(bookedSlot));
      } else {
        setGeneratedLink("");
      }
    }
  }, [bookedSlotId, selectedJob]);

  const formatTime = (timeStr) => {
    if (!timeStr) return "";
    const date = new Date(timeStr.replace(" ", "T"));
    return date.toLocaleTimeString([], {
      hour: "numeric",
      minute: "2-digit",
      hour12: !use24HourFormat,
    });
  };

  const handleGenerateMeeting = async () => {
    if (!selectedSlotId) return false;

    setIsGeneratingLink(true);
    try {
      const response = await InterViewSlotService.generateMeetingLink(
        selectedSlotId,
      );
      const calendarScheduled = extractCalendarEventScheduled(response);
      const link = extractMeetingLink(response);

      if (isVideoSlot) {
        if (link) {
          setGeneratedLink(link);
          toast.success("Meeting link generated");
        } else {
          toast.info("No meeting link returned from server");
        }
      } else {
        setShowCalendarScheduledMessage(calendarScheduled);
      }

      return true;
    } catch (error) {
      setShowCalendarScheduledMessage(false);
      toast.error(error.message || "Failed to schedule meeting");
      return false;
    } finally {
      setIsGeneratingLink(false);
    }
  };
console.log("selectedSlotStatus", selectedSlotStatus);
  const handleSlotBooking = async () => {
    if (!selectedSlotId || !selectedSlotStatus) return;

    setIsBooking(true);
    try {
      const payload = {
        candidate_id:
          candidate?.data?.candidate?.id || candidate?.data?.candidate_id,
        status: selectedSlotStatus,
      };

      await InterViewSlotService.bookSlot(selectedSlotId, payload);

      setSavedSlotStatus(selectedSlotStatus);

      toast.success(
        selectedJob?.booked_interview_slot
          ? "Slot updated successfully"
          : "Slot booked successfully",
      );

      if (selectedSlotStatus === "confirmed") {
        setShowCalendarScheduledMessage(false);
        if (isVideoSlot) {
          setGeneratedLink("");
        } else {
          await handleGenerateMeeting();
        }
      } else {
        setShowCalendarScheduledMessage(false);
        setGeneratedLink("");
      }

      if (onSuccess) onSuccess();
    } catch (error) {
      toast.error(error.message || "Failed to book slot");
    } finally {
      setIsBooking(false);
    }
  };

  const handleGenerateLink = async () => {
    const success = await handleGenerateMeeting();
    if (success && onSuccess) onSuccess();
  };

  return (
    <div className="flex flex-col gap-4 w-[95vw] sm:w-[85vw] md:w-[70vw] lg:w-[60vw] max-w-3xl bg-card rounded max-h-[85vh] overflow-visible p-4 sm:p-5">
      <h2 className="text-xl font-semibold text-foreground">Available Slots</h2>
      <div className="flex flex-col gap-2 flex-1">
        <div>
          <label className="font-semibold text-foreground">Select Date</label>
          <Dropdown
            options={
              selectedJob?.booked_interview_slot
                ? [
                  {
                    value: selectedJob.booked_interview_slot.id,
                    label: new Date(
                      selectedJob.booked_interview_slot.date,
                    ).toLocaleDateString("en-US", {
                      weekday: "short",
                      month: "short",
                      day: "numeric",
                      year: "numeric",
                    }),
                  },
                ]
                : selectedJob?.company_availability_blocks
                  ?.filter((b) => b.slots?.length > 0)
                  .map((block) => ({
                    value: block.id,
                    label: new Date(block.date).toLocaleDateString("en-US", {
                      weekday: "short",
                      month: "short",
                      day: "numeric",
                      year: "numeric",
                    }),
                  })) || []
            }
            value={
              selectedDateId
                ? {
                  value: selectedDateId,
                  label: new Date(
                    selectedBlock?.date || "",
                  ).toLocaleDateString("en-US", {
                    weekday: "short",
                    month: "short",
                    day: "numeric",
                    year: "numeric",
                  }),
                }
                : null
            }
            onChange={(opt) => {
              setSelectedDateId(opt.value);
              setSelectedSlotId("");
              setSavedSlotStatus("");
              setShowCalendarScheduledMessage(false);
              setGeneratedLink("");
            }}
            placeholder="Choose a date"
            searchable={true}
            disabled={!!selectedJob?.booked_interview_slot}
            renderInPortal={true}
          />
        </div>

        <div>
          <label className="font-semibold text-foreground">Select Slot</label>
          <div className="mt-2 mb-3 flex items-center justify-between rounded-md border border-border px-3 py-2">
            <span className="text-sm font-medium text-foreground">
              12h / 24h Time Format
            </span>
            <button
              type="button"
              onClick={() => setUse24HourFormat((prev) => !prev)}
              className={`relative inline-flex h-6 w-11 items-center rounded-full border border-border transition-colors ${
                use24HourFormat ? "bg-primary-dark border-transparent" : "bg-muted"
              }`}
              aria-pressed={use24HourFormat}
              aria-label="Toggle 12h and 24h time format"
            >
              <span
                className={`inline-block h-4 w-4 transform rounded-full bg-card border border-border shadow-sm transition-transform ${
                  use24HourFormat ? "translate-x-6" : "translate-x-1"
                }`}
              />
            </button>
          </div>
          <Dropdown
            options={
              selectedJob?.booked_interview_slot
                ? selectedJob.booked_interview_slot.slots?.map((slot) => ({
                  value: slot.id,
                  label: `${formatTime(slot.start_time)} - ${formatTime(slot.end_time)}`,
                }))
                : selectedBlock?.slots?.map((slot) => ({
                  value: slot.id,
                  label: `${formatTime(slot.start_time)} - ${formatTime(slot.end_time)} (${slot.status})`,
                })) || []
            }
            value={
              selectedSlotId
                ? {
                  value: selectedSlotId,
                  label: `${formatTime(selectedSlot?.start_time)} - ${formatTime(selectedSlot?.end_time)}${!selectedJob?.booked_interview_slot ? ` (${selectedSlot?.status})` : ""}`,
                }
                : null
            }
            onChange={(opt) => {
              const slot = selectedBlock?.slots?.find(
                (s) => String(s.id) === String(opt.value),
              );
              setSelectedSlotId(opt.value);
              setSelectedSlotStatus(null);
              setSavedSlotStatus(slot?.status || "");
              setShowCalendarScheduledMessage(false);
              setGeneratedLink("");
            }}
            placeholder="Choose a slot"
            disabled={!selectedDateId || !!selectedJob?.booked_interview_slot}
            searchable={true}
            renderInPortal={true}
          />
        </div>
        {selectedSlotId && (
          <div>
            <label className="font-semibold text-foreground">Select Status</label>
            <Dropdown
              options={[
                { value: "open", label: "Open" },
                { value: "pending", label: "Pending" },
                { value: "confirmed", label: "Confirmed" },
              ]}
              value={
                selectedSlotStatus
                  ? {
                    value: selectedSlotStatus,
                    label:
                      selectedSlotStatus.charAt(0).toUpperCase() +
                      selectedSlotStatus.slice(1),
                  }
                  : null
              }
              onChange={(opt) => {
                setSelectedSlotStatus(opt.value);
                setShowCalendarScheduledMessage(false);
                if (opt.value !== "confirmed") {
                  setGeneratedLink("");
                }
              }}
              placeholder="Choose a status"
              searchable={true}
              renderInPortal={true}
            />
          </div>
        )}
        {savedSlotStatus === "confirmed" &&
          isVideoSlot &&
          generatedLink &&
          !isBooking &&
          !isGeneratingLink && (
          <div>
            <label className="font-semibold cursor-pointer">Meeting Link</label>
            <div className="flex items-center w-full mt-1 relative">
              <input
                type="text"
                readOnly
                value={generatedLink}
                className="w-full px-3 py-2 pr-10 text-sm text-foreground bg-muted border border-input rounded-md focus:outline-none focus:border-primary-dark"
              />
              <button
                type="button"
                className="absolute right-2 text-muted-foreground hover:text-foreground focus:outline-none"
                onClick={(e) => {
                  e.preventDefault();
                  navigator.clipboard.writeText(generatedLink);
                  toast.success("Link copied!");
                }}
                title="Copy link"
              >
                <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z" />
                </svg>
              </button>
            </div>
            <p className="text-xs text-green-600 mt-1">
              Your Microsoft Teams link is ready. Copy it to share.
            </p>
          </div>
        )}
        {savedSlotStatus === "confirmed" &&
          showCalendarScheduledMessage &&
          !isVideoSlot &&
          !isBooking &&
          !isGeneratingLink && (
          <div >
            <h3 className="font-semibold text-foreground">Event Scheduled</h3>
            <p className="text-sm text-muted-foreground rounded-lg mt-2 border border-border bg-muted px-4 py-3">
              The event has been scheduled successfully. Please check your calendar
              for details.
            </p>
          </div>
        )}
        {(isBooking || isGeneratingLink) && (
          <div className="flex items-center gap-3 p-3 mt-2 bg-primary-dark text-white rounded-lg border border-indigo-400">
            <svg className="animate-spin h-5 w-5 text-white" viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <circle cx="12" cy="12" r="10" strokeWidth="4" strokeOpacity="0.3"></circle>
              <path d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" fill="currentColor"></path>
            </svg>
            <span className="text-sm font-semibold tracking-wide animate-pulse">
              {isGeneratingLink
                ? isVideoSlot
                  ? "Generating meeting link. Please wait..."
                  : "Scheduling calendar event. Please wait..."
                : "Updating slot. Please wait..."}
            </span>
          </div>
        )}
      </div>
      <div
        className={`flex flex-col-reverse sm:flex-row sm:items-center gap-2 ${
          isVideoSlot &&
            selectedSlotId &&
            !generatedLink &&
            savedSlotStatus === "confirmed"
            ? "sm:justify-between"
            : "sm:justify-end"
        }`}
      >
        {isVideoSlot &&
          selectedSlotId &&
          !generatedLink &&
          savedSlotStatus === "confirmed" && (
          <button
            type="button"
            disabled={isBooking || isGeneratingLink}
            onClick={handleGenerateLink}
            className="w-full sm:w-auto px-4 py-2 text-sm font-medium text-primary-dark bg-card border border-primary-dark rounded-md hover:bg-muted disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {isGeneratingLink ? "Generating..." : "Generate Link"}
          </button>
        )}
        <div className="flex flex-col-reverse sm:flex-row gap-2">
          <button
            onClick={handleCloseSlots}
            className="w-full sm:w-auto px-4 py-2 text-sm font-medium text-foreground bg-card border border-input rounded-md hover:bg-muted"
          >
            Cancel
          </button>
          <button
            disabled={
              !selectedSlotId || !selectedSlotStatus || isBooking || isGeneratingLink
            }
            onClick={handleSlotBooking}
            className="w-full sm:w-auto px-4 py-2 text-sm font-medium text-white bg-primary-dark rounded-md hover:bg-primary-dark disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {isBooking
              ? selectedJob?.booked_interview_slot
                ? "Updating..."
                : "Booking..."
              : selectedJob?.booked_interview_slot
                ? "Update Slot"
                : "Book Slot"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default InterviewDetailsForm;
